// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck-faq-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ck-faq-list {
  width: 100%;
  max-width: 600px;  
  margin: 0 auto;
}

.ck-faq-item {
    
  padding: 15px 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  transition: none;

}

/* OPEN state me width badha do */
.ck-faq-item-active {
  max-width: 100% !important;  /* FULL WIDTH */
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Faq.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAGE,kBAAkB;EAClB,mBAAmB;EAMnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;;AANlB;;AASA,iCAAiC;AACjC;EACE,0BAA0B,GAAG,eAAe;EAC5C,sBAAsB;AACxB","sourcesContent":[".ck-faq-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.ck-faq-list {\r\n  width: 100%;\r\n  max-width: 600px;  \r\n  margin: 0 auto;\r\n}\r\n\r\n.ck-faq-item {\r\n  width: 100%;\r\n    \r\n  padding: 15px 20px;\r\n  border-radius: 10px;\r\n\r\n}\r\n\r\n\r\n.ck-faq-item {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  transition: none;\r\n}\r\n\r\n/* OPEN state me width badha do */\r\n.ck-faq-item-active {\r\n  max-width: 100% !important;  /* FULL WIDTH */\r\n  width: 100% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
